<template>
  <el-container>
    <el-row v-if="meta.errMsg" type="flex" justify="center" align="middle" class="f-h f-w">
      <h2 class="danger">{{ meta.errMsg }}</h2>
    </el-row>
    <el-row v-else-if="!meta.inited" type="flex" justify="center" align="middle" class="f-h f-w">
      <el-row class="center">
        <img v-if="theme" :src="theme.loadingImgFile" />
        <h2>正在加载，请稍后…</h2>
      </el-row>
    </el-row>
    <editor v-show="meta.inited && !meta.errMsg" ref="editor" :visible="true" :main="mrMain.curr" is-embed :readonly="readonly" />
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {
    editor: () => import("@/components/mrMain/dlgEditor"),
  },
  data() {
    return {
      no: null, // 门诊号或者住院号
      entity: null, // 门诊就诊记录或者住院记录
      meta: {
        errMsg: null,
        loading: false,
        saving: false,
        inited: false,
        showLeft: true,
        showRight: false,
        leftAct: "mrs",
      },
      mrMain: {
        origin: null,
        curr: null,
      },
      collection: {
        items: [],
        show: false,
      },
    };
  },
  computed: {
    ...mapGetters(["token", "theme", "user", "dict", "Enum"]),
    isIp() {
      // 是否是住院
      return !!this.mrMain.curr?.ipNo || !!this.$route.query.ip;
    },
    readonly() {
      return this.$route.query.readonly;
    },
  },
  created() {
    this.$utils.log("emr studio created");
  },
  async mounted() {
    this.$utils.log("emr studio mouted");

    // window.addEventListener("beforeunload", (e) => {
    //   this.$utils.log("emr studio beforeunload");
    //   if (this.isIp) {
    //     this.save();
    //     this.unlock();
    //   } else {
    //     this.save(true);
    //   }
    // });
    // window.addEventListener("pagehide", (e) => {
    //   this.$utils.log("emr studio pagehide");
    //   if (this.isIp) {
    //     this.unlock();
    //   } else {
    //     this.save(true);
    //   }
    // });
    window.addEventListener("message", (e) => {
      this.$utils.log("emr studio message", e.data);
      if (e.data.event == "diagonosis") {
        this.updateDiagnosis(e.data.data);
      } else if (e.data.event == "refresh") {
        this.init(e.data.data);
      } else if (e.data.event == "save") {
        if (this.meta.errMsg) {
          return;
        }
        this.$message.success("病历保存中，请稍后……");
        this.save(e.data.data);
      } else if (e.data.event == "unlock") {
        this.unlock();
      }
    });
    // console.log(this.$route, "$route");
    // window.updateDiagnosis = this.updateDiagnosis;
    // window.reloadMrMain = this.init;
    if (await this.login()) {
      await this.init();
    }
  },
  methods: {
    async login() {
      if (!this.$route.query.ip && !this.$route.query.op) {
        this.meta.errMsg = "就诊号不能为空！";
        return false;
      }
      if (this.$route.query.token) {
        this.$utils.saveToken({ access_token: this.$route.query.token, refresh_token: this.$route.query.token });
        this.$store.dispatch("init");
        this.$utils.wait(1000);
        const usr = await this.$api.User.get();
        this.$store.commit("user", usr);
        this.$store.dispatch("loaders", "MrTemplate");
        this.$store.dispatch("loaders", "MrElement");
        while (!this.dict.MrElement) {
          await this.$utils.wait(1000);
        }
        const { op, ip, dept, mrCategory, readonly } = this.$route.query;
        this.$router.replace({
          name: "studio",
          query: { op, ip, dept, mrCategory, readonly },
        });
      }
      if (!this.token) {
        this.meta.errMsg = "抱歉，当前用户尚未登录！";
        return false;
      }
      return true;
    },
    async init(no) {
      this.meta.errMsg = null;
      this.meta.inited = false;
      this.$utils.log("加载病历");
      if (no) {
        this.no = no;
      } else {
        if (this.$route.query.ip) {
          this.no = this.$route.query.ip;
        } else if (this.$route.query.op) {
          this.no = this.$route.query.op;
        }
      }

      let mains = (await this.$api.MrMain.query({ nos: this.no })).items;
      this.$utils.log(`查找病历，No=${this.no}`, mains);
      if (this.readonly) {

      }
      if (!mains[0]) {
        if (this.readonly) {
          this.meta.errMsg = "病历不存在！";
          return
        }
        if (this.isIp) {
          this.entity = await this.$api.getIp(this.no);
          this.$utils.log("查找住院记录", this.entity);
        } else {
          this.$utils.log("查找门诊记录", this.entity);
          this.entity = await this.$api.getOp(this.no);
        }
        if (!this.entity) {
          this.meta.errMsg = "未找到相关就诊记录！";
          return;
        }
        if (!this.entity.patientCode || !this.entity.patientName) {
          this.meta.errMsg = "就诊记录中缺少患者信息，无法创建病历！";
          return;
        }
        if (!this.entity.deptCode || !this.entity.doctorCode) {
          this.meta.errMsg = "就诊记录中缺少科室或医生信息，无法创建病历！";
          return;
        }

        this.mrMain.curr = await this.$api.MrMain.save({
          opNo: this.isIp ? null : this.no,
          ipNo: this.isIp ? this.no : null,
          patientCode: this.entity.patientCode,
          patientName: this.entity.patientName,
          patientGender: this.entity.patientGender,
          patientAge: this.entity.patientAge,
          deptCode: this.entity.deptCode,
          doctorCode: this.entity.doctorCode,
          doctorName: this.entity.doctorName,
          diagnosis: this.entity.diagnosis || this.entity.diagnosisName,
          opTime: this.entity.takingDate || this.entity.startDate,
          submitTime: this.$utils.Dt.now(),
          submitUserCode: this.user.id,
          submitUserName: this.user.name,
          qcState: this.Enum.MrQCState.待质控,
          nos: JSON.stringify([this.no]),
          ifArchived: false,
          editingUserCode: this.user.id,
          editingUserName: this.user.name,
        });
        this.mrMain.origin = this.mrMain.curr;
      } else {
        if (!this.readonly) {
          try {
            this.$utils.log("锁定病历");
            this.mrMain.curr = await this.$api.MrMain.lock(mains[0].id);
            this.$utils.log(this.mrMain.curr);
          } catch (err) {
            this.meta.errMsg = err;
            return;
          }
        }

        this.mrMain.origin = mains[0];
      }
      // 向父窗口传递参数
      if (window.parent) {
        window.parent.postMessage({ event: "mrMain", data: this.mrMain.origin }, "*");
      }
      this.meta.inited = true;
    },
    updateDiagnosis(diagnosis) {
      this.$api.MrMain.patch({ id: this.mrMain.origin.id, diagnosis }).catch((err) => {
        console.log(err);
      });
    },
    save(isSubmit) {
      this.$refs.editor.save(isSubmit);
    },
    unlock() {
      this.$refs.editor.unlock();
    },
  },
};
</script>
